import * as yup from 'yup';

const precision = 21;
const scale = 8;
const maxValue = Number(`${'9'.repeat(precision-scale)}.${'9'.repeat(scale)}`);
const minValue = Number(`0.${'0'.repeat(scale)}`);

export const FinancialInformationValidationSchema = yup.object().shape(
	{
		turnover: yup
			.number()
			.nullable()
			.transform((curr, orig) => (orig === '' ? null : curr))
			.typeError('Turnover must be a valid number')
			.max(maxValue, 'Value too large')
			.min(minValue, 'Value too small')
			.required('Turnover is required'),
		netProfitAfterTax: yup
			.number()
			.nullable()
			.transform((curr, orig) => (orig === '' ? null : curr))
			.typeError('Net Profit After Tax must be a valid number')
			.max(maxValue, 'Value too large')
			.min(minValue, 'Value too small')
			.required('Net Profit After Tax is required'),
		numberOfEmployees: yup
			.number()
			.integer('Please enter a valid Number of Employees without decimal values')
			.transform((curr, orig) => (orig === '' ? null : curr))
			.typeError('Number Of Employees must be a valid number')
			.required('Number of Employees is required'),
		financialYearEnd: yup
			.string()
			.nullable()
			.required('Financial Year End is required'),
		accountType: yup
			.string()
			.nullable()
			.required('Account Type is required'),
	}
);
